<template>
  <div class="privacy-page">
    <!-- 隐私政策内容 -->
    <div class="privacy-content">
      <div class="content-container">
        <h1 class="main-title">《星果》平台隐私政策</h1>
        <p class="update-date">更新日期：2026年10月30日 | 生效日期：2026年10月30日</p>

        <section class="section policy-update" aria-label="本次更新说明">
          <p class="note"><strong>本次更新：</strong>补充<a href="#push-notices">消息推送的用途、信息处理与关闭方式</a>，以及<a href="#push-sdks">华为、小米、vivo、OPPO 推送 SDK 说明</a>。</p>
        </section>

        <section class="section">
          <h2>【前言】</h2>
          <p>《星果》APP和编辑器共称为星果平台（以下也称 "我们"）一向庄严承诺保护使用我们的用户（以下统称"用户"或"您"）的个人信息和隐私安全。您在使用我们提供的免费服务时，我们可能会收集和使用您的相关个人信息。我们希望通过《星果平台隐私政策》（以下简称"本政策"）向您说明我们在收集和使用您相关个人信息时对应的处理规则等相关事宜，以便更好地保障您的权益。</p>
        </section>

        <section class="section">
          <h2>【特别提示】</h2>
          <div class="tip-item">
            <p><strong>1.</strong> 本政策适用于我们提供的星果APP和编辑器（以下亦称："本产品"）服务。本政策与《星果平台使用许可及服务协议》同时对您产生效力。</p>
          </div>
          <div class="tip-item">
            <p><strong>2.</strong> 未满十四周岁的用户，同时适用《星果平台使用许可及服务协议》、《星果未成年人信息保护规则和监护人须知》、本政策。</p>
          </div>
          <div class="tip-item">
            <p>本政策将帮助您了解以下内容。在使用星果前，请您务必审慎阅读、充分理解各项条款内容，特别是免除或限制责任的条款。限制、免责条款可能以加粗形式提示您注意。</p>
          </div>
          <div class="tip-item">
            <p><strong>3.</strong> 本政策约定了在不同场景下我们处理您的信息的方式，但只有当您开启相关功能或使用相关服务时，为实现相关功能、服务，我们才会处理您的信息。如您不开启相关功能或使用相关服务，则我们不会处理您对应的信息。除本政策外，我们还会通过即时告知如弹窗、页面提示等方式，向您说明我们的信息收集目的、范围及使用方式，这些即时告知内容构成本政策的一部分，并与本政策具有同等效力，请您特别留意。</p>
          </div>
          <div class="tip-item">
            <p><strong>4.</strong> 在使用本产品服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。如果您不同意本政策的内容，将可能导致本产品服务无法正常运行，或者无法达到我们拟达到的服务效果，您应立即停止访问/使用本产品服务。</p>
          </div>
          <p>在阅读完本政策后，如您对本政策或与本政策相关的事宜有任何问题，您可通过本政策"如何联系我们"章节所列的反馈渠道联系我们，我们会尽快为您作出解答。</p>
        </section>

        <section class="section">
          <h2>本政策将帮助您了解以下内容：</h2>
          <ul class="toc">
            <li>一、我们如何收集和使用您的个人信息</li>
            <li>二、我们如何使用COOKIES或同类技术</li>
            <li>三、我们如何共享、转移和公开您的个人信息</li>
            <li>四、我们如何存储和保护您的个人信息</li>
            <li>五、如何行使您的个人信息相关权利</li>
            <li>六、未成年人保护</li>
            <li>七、修订和通知</li>
            <li>八、如何联系我们</li>
          </ul>
        </section>

        <section class="section">
          <h2>一、我们如何收集和使用个人信息</h2>

          <h3>（一）我们将通过以下途径收集和获得您的个人信息：</h3>

          <h4>1、您主动提供的信息。</h4>
          <p>（1）您在注册本产品的帐号或使用本产品服务时，向我们提供的信息；</p>
          <p>（2）您使用本产品服务时所存储的信息。</p>
          <p class="note">请注意，如您在本产品中其他用户可见的公开区域内公开您的信息，该等信息可能会被他人收集并加以使用。当您发现他人不正当地收集或使用您的信息时，可通过本政策"如何联系我们"章节所列的反馈渠道联系我们。</p>

          <h4>2、第三方共享的您的信息。</h4>

          <h4>3、我们在向您提供服务的过程中合法获取的您的信息。</h4>
          <p>您在使用本产品服务时，我们收集、汇总、记录的信息。</p>

          <h3>（二）我们会出于以下目的，收集和使用您以下类型的个人信息：</h3>

          <h4>1、帮助您完成注册及登录</h4>
          <p>为便于我们为您提供持续稳定的服务并保障您使用产品的安全性，在您登录编辑器时，我们需要您提供基本注册或登录信息，包括手机号码、电子邮箱，并生成您的帐号、用户名和密码。如果您仅需使用搜索、浏览等基础功能，您不需要注册或登录及提供上述信息。</p>

          <h4>2、进行实名认证</h4>
          <p>依照相关法律法规规定及监管要求，或为满足用户身份真实核验、保障系统和服务安全需要，您在使用特定功能及服务前，需要进行实名认证。在这种情况下，为实现实名认证的目的，我们可能委托第三方提供实名认证服务，您同意并授权我们可能以自行或委托第三方向有关实名认证机构（国家相关主管部门、公安部门或者其委托/合作的其他机构）提供、查询、核对您的前述身份信息。</p>
          <p>您也可以使用我们认可的第三方平台的帐号登录，当您使用我们认可的第三方平台的帐号登录星果APP时，我们将根据您的授权获取该等账号下的相关信息（包括：用户名、昵称、头像、唯一标识以及好友关系或其他经您授权信息），用于帮助您完成注册、登录。</p>

          <h4>3、维护基本功能的正常运行、网络及运营安全</h4>
          <p>在您使用我们的服务过程中，为向您提供浏览、搜索等基本功能，并识别帐号异常状态、了解产品适配性、保障本产品服务的网络及运营安全，以维护前述基本功能的正常运行，我们可能会收集、存储关于您使用的服务以及使用方式的日志信息、设备信息、帐号信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，并将这些信息进行关联来综合判断您帐号及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施：</p>
          <p>(1) 日志信息：当您使用我们的服务时，我们会收集您的登录日志、操作信息、互动记录、ID、搜索查询内容、IP地址、软件列表、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、停留时长、刷新记录、发布记录、关注、订阅、收藏及分享。</p>
          <p>(2) 设备信息：我们会接收并记录您所使用的设备相关信息：设备机型（计算机名称）、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、设备标识符（Android ID/OAID/IDFA/OpenUDID/GUID）、软硬件特征信息、IP 地址，这类信息是为提供服务必须收集的基础信息。</p>
          <p>(3) <strong>设备标识符（含 Android ID）专项说明：</strong>为在<strong>不收集 IMEI、MAC 地址等不可变更硬件标识符</strong>的前提下识别设备，我们以及本政策"第三方SDK目录"所列的第三方SDK会收集以下可重置的设备标识符：<strong>Android ID</strong>（系统为每台设备分配的标识码，通过 Android 系统接口 Settings.Secure.ANDROID_ID 在您的设备本地读取，恢复出厂设置后即会变更）、<strong>OAID</strong>（移动智能终端补充设备标识符，由终端厂商提供，您可在系统设置中重置或关闭）。收集范围仅限于上述标识符本身，不涉及您的通讯录、短信、通话记录、相册等信息；收集目的仅限于：设备维度的统计去重与账号安全风控、广告投放的转化归因与效果统计、广告反作弊校验、推送设备识别与消息投递，<strong>我们不会将其用于识别您的真实身份</strong>；收集方式为在您的设备本地通过系统接口读取后加密传输，且全部发生在您阅读并同意本政策之后——在您点击同意之前，我们与第三方SDK均不会读取上述标识符。各第三方SDK对 Android ID 的具体收集情况，详见本政策"第三方SDK目录"。</p>
          <p class="note">请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。如果我们将该类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，该类非个人信息将被视为个人信息，我们会将该类个人信息做匿名化、去标识化处理，但您授权或法律法规另有规定的除外。该类信息在结合使用期间，将作为您的个人信息按照本政策处理与保护。</p>

          <h4>4、向您提供互动与发布服务</h4>
          <p>您在使用本产品服务时、上传或发布信息以及进行相关互动行为（如有发言、跟贴、留言分享、收藏、点赞）时，我们将收集您上传、发布或形成的信息，并使用您的昵称、头像和发布内容进行严格的审核后以作展示。</p>
          <p class="note">请注意，您公开发布的信息中可能包含您的个人信息或个人敏感信息，该等信息可能会被他人收集并加以使用，请您在发布前慎重考虑。如您发布的信息涉及到他人的个人信息的，您应当在发布前征得他人同意。当您发现他人不正当地收集或使用您的信息时，可通过本政策"如何联系我们"章节所列的反馈渠道联系我们。</p>

          <h4>5、为您提供客服或其他用户响应功能</h4>
          <p>当您联系我们的客服或使用其他用户响应功能时（个人信息保护投诉或建议、其他客户投诉和需求），我们需要您提供必要的个人信息以匹配并核验您的用户身份，以便保障您的帐号与系统安全。为处理您的诉求，人工客服需要在您授权范围内(相机权限、录音权限等)查询或核验您的相关信息并仅在必要范围内使用，如您拒绝提供或提供错误的，我们将无法向您提供相应支持。在确认您用户身份后，我们还会保存您的联系方式（您向我们主动提供的联系方式）、您与我们的通信/通话记录和内容、与您需求相关联的其他必要信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>

          <h4>6、个性化广告</h4>
          <p>基于我们获得的您的个人信息（您的浏览及搜索记录、设备信息（具体包括：设备型号、操作系统版本、设备标识符（OAID/Android ID）、网络类型）、广告展示与点击数据、软件安装列表、粗略位置信息），我们会基于上述一项或几项信息的结合，提取您的浏览、搜索偏好、行为习惯相关特征，以便向您提供更契合您需求的个性化广告。如您不希望接受个性化广告服务，您可以通过"设置-个性化广告"随时关闭该功能；关闭后您仍会看到广告，但广告与您的相关性会降低。如有任何问题，您可以与我们联系。</p>

          <h4>7、权限申请说明</h4>
          <p>您理解并同意，使用本产品服务的过程中，我们将在必要时申请访问您的系统、设备权限，以实现这些权限所涉及信息的收集和使用。我们在开启权限前，将告知您开启权限的目的并征求您的同意，如您不同意，我们将不会开启相关权限，也无法为您提供该权限所对应的服务。</p>
          <p>（1）在您同意访问存储权限后，您允许我们访问您的存储空间，以便使您可以下载并保存内容，或者通过缓存来实现相应服务功能；</p>
          <p>（2）在您同意访问相机权限后，您能够上传、拍摄照片/图片/视频，实现发布信息和评论、或与客服沟通提供证明功能；</p>
          <p>（3）在您同意访问麦克风权限后，您能够与我们的产品、或与客服联系；</p>
          <p>（4）通知权限：用于展示章节更新、阅读及奖励提醒、书籍推荐等推送消息。在需要运行时授权的系统版本（如 Android 13 及以上）上，我们会请求通知权限；您可以拒绝，也可随时在系统设置中关闭通知，不影响阅读等基础功能。</p>
          <p class="note">有关特定功能权限的提示：如您需要关闭为使用上述特定功能而开启的功能权限时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。您也可以与我们联系。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</p>
          <p>如果我们要将您的个人信息用于本政策中未载明的其他用途或额外收集未提及的其他个人信息，我们会依法通过页面提示、弹窗或其他方式另行征得您的同意。</p>

          <h4 id="push-notices">8、消息推送与通知管理</h4>
          <p><strong>推送用途：</strong>我们通过通知栏向您发送收藏作品的新章节提醒、正在阅读作品的继续阅读提醒、书籍推荐及签到奖励提醒。我们会使用您的收藏记录、近期阅读记录及时间、当天签到状态、青少年模式状态和历史推送记录，选择适用的内容、过滤不适宜的作品并控制发送频次。</p>
          <p><strong>我们处理的信息：</strong>为向您的设备投递消息，我们会处理应用安装标识、厂商分配的推送标识（Push Token / RegID / RegistrationID）、推送厂商、应用标识、账号推送开关和通知权限状态，并在您登录后将上述信息与您的星果账号关联。为完成消息投递、故障排查、频次控制和效果统计，我们还会保存消息标识、标题、内容、点击后打开的页面及必要参数、发送结果、送达或失败等厂商回执、点击记录和相关时间。厂商回执仅能反映其支持的状态，送达不代表您已阅读通知。</p>
          <p><strong>厂商服务：</strong>我们在您同意本政策后，根据设备品牌及服务支持情况启用对应的华为、小米、vivo 或 OPPO 推送 SDK。为完成投递，对应厂商会处理推送标识、消息内容及必要的投递参数；SDK 涉及的其他信息、处理目的和官方说明见下方“第三方 SDK 目录”。这些推送标识用于定位应用接收端，并非您的手机号码。</p>
          <p><strong>关闭方式：</strong>您可在星果“我的 → 设置 → 消息推送”中关闭当前账号的推送。保存成功后，我们将停止向该账号的所有设备发送新推送，并取消尚未开始发送的排队消息；已开始投递或已由厂商接收的消息可能仍会到达。重新开启不会补发已取消的消息。该设置随账号保存，重新登录或换设备不会重置。您也可随时在手机“系统设置 → 应用 → 星果 → 通知”中关闭通知或调整通知类别，具体名称以手机系统为准。拒绝或关闭通知不会影响阅读等基础功能。系统通知开关控制的是通知展示；App 内推送开关控制的是我们是否向账号发送推送，二者均不等同于撤回 SDK 信息处理授权或删除既有记录；如需撤回相关授权、解除推送关联或删除推送相关个人信息，请通过本政策“如何联系我们”所列渠道提出申请。退出登录后，应用会向服务端请求解除当前账号的推送绑定；网络不可用时将在恢复连接后重试。</p>

          <h4>9、征得授权同意的例外</h4>
          <p>根据相关法律法规规定，以下情形中处理您的信息无需征得您的授权同意：</p>
          <p>（1）为订立、履行您作为一方当事人的合同所必需；</p>
          <p>（2）为履行法定职责或者法定义务所必需；</p>
          <p>（3）为应对突发公共卫生事件，或者紧急情况下为保护您或他人的生命健康和财产安全所必需；</p>
          <p>（4）为公共利益实施新闻报道、舆论监督等行为，在合理范围内处理您的个人信息；</p>
          <p>（5）在合理范围内处理您自行公开或者其他已经合法公开的个人信息；</p>
          <p>（6）法律、行政法规规定的其他情形。</p>
        </section>

        <section class="section">
          <h2>二、我们如何使用COOKIES或同类技术</h2>
          <p>我们或我们的第三方合作伙伴可能通过COOKIES或同类技术获取和使用您的信息，并将该等信息存储为日志信息。</p>
          <p>通过使用COOKIES，我们向用户提供简单易行并富个性化的网络体验。一个COOKIES是少量的数据，它们从一个网络服务器送至您的浏览器并存在计算机硬盘上。我们使用COOKIES是为了让其用户可以受益。比如，为使得星果登录过程更快捷，您可以选择把用户名存在一个COOKIES中。这样下次当您要登录服务时能更加方便快捷。COOKIES能帮助我们确定您连接的页面和内容，您能减少在星果特定服务上花费的时间和您所选择的本产品服务。</p>
          <p>COOKIES使得我们能更好、更快地为您服务，并且使您在本产品服务上的经历更富个性化。然而，您应该能够控制COOKIES是否以及怎样被您的浏览器接受。请查阅您的浏览器附带的文件以获得更多这方面的信息。</p>
          <p>我们和第三方合作伙伴可能通过COOKIES或同类技术收集和使用您的信息，并将该等信息存储。</p>

          <h3>我们使用自己的COOKIES或同类技术，可能用于以下用途：</h3>
          <p>1、记住您的身份。COOKIES或同类技术有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的内容喜好或其他信息；</p>
          <p>2、分析您使用我们服务的情况。我们可利用COOKIES或同类技术来了解您使用本产品服务进行什么活动、或哪些服务最受欢迎；</p>
          <p>3、广告优化。COOKIES或同类技术有助于我们根据您的信息，向您提供您可能更感兴趣的广告而非进行普遍的广告投放。</p>
          <p>我们为上述目的使用COOKIES或同类技术的同时，可能将通过COOKIES或同类技术收集的非个人身份信息汇总提供给广告商和其他伙伴，用于分析您和其他用户如何使用本产品服务并用于广告服务。</p>
          <p>本产品服务上可能会有广告商和其他合作方放置的COOKIES或同类技术。这些COOKIES和或同类技术可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方COOKIES或同类技术收集和使用该等信息不受本政策约束，而是受到其自身的信息保护声明约束，我们不对第三方的COOKIES或同类技术承担责任。</p>
          <p>您可以通过浏览器或用户选择机制拒绝或管理COOKIES或同类技术。但请您注意，如果您停用COOKIES或同类技术，我们有可能无法为您提供最佳的服务体验，某些服务也可能无法正常使用。同时，您仍然将收到广告，只是这些广告与您的相关性会降低。</p>
        </section>

        <section class="section">
          <h2>三、我们如何共享、转移或公开您的个人信息</h2>

          <h3>（一）共享</h3>
          <p>我们非常重视保护您的个人信息。我们仅会出于合法、正当、必要、特定、明确的目的向第三方提供您的个人信息。接收我们提供个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息。</p>

          <h4>1、为实现本政策中声明的目的，我们会接入第三方服务商提供的SDK或其他类似的应用程序（包括嵌入代码、插件、HTML），以便向您提供更好的客户服务和用户体验。为实现我们服务而可能委托处理或者共享个人信息的情形如下。</h4>
          <p>（1）用于广告相关服务，包括广告展示、广告数据监测/统计；</p>
          <p>（2）用于支付相关服务，包括收入结算、支付信息汇总统计；</p>
          <p>（3）用于在您同意的情况下获取设备位置权限、搜集设备信息和日志信息；</p>
          <p>（4）用于第三方授权服务，包括我们认可的第三方帐号登陆；</p>
          <p>（5）用于支持产品功能模块，包括智能客服、内容存储；</p>
          <p>（6）用于优化产品性能和服务质量，包括提高硬件配网能力、降低服务器成本、功能热修复、安全分析、优化服务、提升用户体验；</p>
          <p>（7）用于帐号安全、产品加固相关服务，包括网络监测、域名解析、防劫持、反垃圾反作弊、加解密服务；</p>
          <p>（8）用于消息推送，包括推送设备注册、消息投递及送达、失败和点击等状态统计。</p>

          <h4>2、我们接入的部分第三方SDK或类似应用程序可能会收集您的个人信息，如您在我们的服务中使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。我们会评估这类第三方服务收集个人信息的合法性、正当性、必要性，要求该等第三方对您的个人信息采取保护措施，并严格遵守相关法律法规与监管要求。</h4>
          <p>以上第三方服务由相关的第三方负责运营。您使用该等第三方服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及个人信息保护相关规则（而非本政策）约束，您需要仔细阅读其条款。本政策仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。如您发现这些第三方服务存在风险时，建议您终止相关操作以保护您的合法权益并及时与我们取得联系。</p>

          <div class="sdk-info">
            <h4>第三方SDK目录：</h4>
            <p>下表列明本应用当前集成的全部第三方SDK及其收集个人信息的目的、方式与范围。所有第三方SDK均在您阅读并同意本政策后才会被初始化；在您点击同意之前，我们及下列第三方SDK不会收集下述任何信息。</p>
            <div class="sdk-item">
              <p><strong>1. SDK名称：</strong>移动智能终端补充设备标识体系统一调用SDK（OAID SDK）</p>
              <p><strong>合作方主体：</strong>移动安全联盟（挂靠单位：中国信息通信研究院泰尔终端实验室）</p>
              <p><strong>涉及个人信息：</strong>匿名设备标识符 OAID、VAID、AAID；<strong>Android ID</strong>（即系统接口 Settings.Secure.ANDROID_ID 返回的设备标识码）；设备厂商、设备型号、操作系统版本。</p>
              <p><strong>使用目的：</strong>在<strong>不收集 IMEI、MAC 地址等不可变更硬件标识符</strong>的前提下，为您的设备取得可由您自行重置或关闭的匿名标识符 OAID，用于广告投放的转化归因、广告效果统计与反作弊校验、设备维度的统计去重；当您的设备未支持或已关闭 OAID 时，以 Android ID 作为兜底的设备识别与去重依据。我们不会用其识别您的真实身份。</p>
              <p><strong>使用场景：</strong>您阅读并同意本政策后，App 启动时初始化本 SDK 并完成一次标识符读取；您未同意本政策时不会初始化。</p>
              <p><strong>收集方式：</strong>SDK 通过终端厂商提供的系统服务在您的设备<strong>本地</strong>读取 OAID/VAID/AAID，通过 Android 系统接口 Settings.Secure.ANDROID_ID 在<strong>本地</strong>读取 Android ID；本 SDK 不申请任何系统权限，读取结果仅在设备本地与本应用服务端、本目录所列广告与归因 SDK 之间按上述目的使用。</p>
              <p><strong>官网链接：</strong><a href="http://www.msa-alliance.cn/col.jsp?id=122" target="_blank">http://www.msa-alliance.cn/col.jsp?id=122</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>2. SDK名称：</strong>巨量引擎转化SDK（AppConvert / BDConvert）</p>
              <p><strong>合作方主体：</strong>北京巨量引擎网络技术有限公司</p>
              <p><strong>涉及个人信息：</strong><strong>Android ID</strong>、OAID；设备品牌与型号、操作系统及版本；网络类型与网络状态；本应用包名与版本号；本应用的安装、启动、激活以及注册、充值等关键转化行为事件及其发生时间；IP 地址。</p>
              <p><strong>使用目的：</strong>广告转化归因与效果统计：用于判断您是否通过我们投放的广告下载安装本应用，据此衡量广告投放效果、进行广告费用结算与反作弊校验。我们与该 SDK 不会将上述信息用于识别您的真实身份，也不会用于广告归因统计以外的其他用途。</p>
              <p><strong>使用场景：</strong>您阅读并同意本政策后，App 启动时初始化本 SDK 并上报一次激活事件；您完成注册、充值等关键行为时上报对应的转化事件。</p>
              <p><strong>收集方式：</strong>SDK 以嵌入式代码在您的设备本地读取上述信息（其中 Android ID 通过 Android 系统接口 Settings.Secure.ANDROID_ID 读取，OAID 由本目录第 1 项 SDK 提供），经加密后传输至巨量引擎服务器；不会读取通讯录、短信、相册等与广告归因无关的信息。</p>
              <p><strong>官网链接：</strong><a href="https://event-manager.oceanengine.com/docs/8650/194615/" target="_blank">https://event-manager.oceanengine.com/docs/8650/194615/</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>3. SDK名称：</strong>穿山甲广告SDK（含 GroMore 聚合模块）</p>
              <p><strong>合作方主体：</strong>北京巨量引擎网络技术有限公司</p>
              <p><strong>涉及个人信息：</strong>设备标识符（Android ID、OAID）；设备品牌与型号、操作系统版本、屏幕分辨率；网络类型与运营商信息、IP 地址；软件安装列表；广告的展示、点击、播放完成与奖励发放记录；粗略位置信息（仅在您授权位置权限后收集，拒绝不影响观看广告）。</p>
              <p><strong>使用目的：</strong>向您展示激励视频广告，统计广告的曝光、点击、播放完成与奖励发放情况，进行广告反作弊校验与广告收益结算；在您未关闭个性化广告时，用于提升广告内容与您的相关性。</p>
              <p><strong>使用场景：</strong>您主动点击"观看广告获取奖励"等入口时，加载并播放广告。</p>
              <p><strong>收集方式：</strong>SDK 以嵌入式代码在设备本地读取上述信息并加密传输至其服务器。您可通过"设置-个性化广告"关闭个性化广告推荐。</p>
              <p><strong>官网链接：</strong><a href="https://www.csjplatform.com/privacy" target="_blank">https://www.csjplatform.com/privacy</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>4. SDK名称：</strong>优量汇广告SDK（腾讯广告）</p>
              <p><strong>合作方主体：</strong>深圳市腾讯计算机系统有限公司</p>
              <p><strong>涉及个人信息：</strong>设备标识符（Android ID、OAID）；设备品牌与型号、操作系统版本；网络类型与运营商信息、IP 地址；软件安装列表；广告的展示、点击与播放记录。</p>
              <p><strong>使用目的：</strong>作为聚合广告的广告源之一向您展示激励视频广告，统计广告效果并进行反作弊校验与收益结算。</p>
              <p><strong>使用场景：</strong>您主动点击"观看广告获取奖励"等入口，且该广告源在聚合竞价中胜出时被调用。</p>
              <p><strong>收集方式：</strong>SDK 以嵌入式代码在设备本地读取上述信息并加密传输至其服务器。</p>
              <p><strong>官网链接：</strong><a href="https://qzs.gdtimg.com/union/res/union_cdn/page/dev_rules/ylh_sdk_privacy_statement.html" target="_blank">https://qzs.gdtimg.com/union/res/union_cdn/page/dev_rules/ylh_sdk_privacy_statement.html</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>5. SDK名称：</strong>快手广告SDK</p>
              <p><strong>合作方主体：</strong>北京快手广告有限公司</p>
              <p><strong>涉及个人信息：</strong>设备标识符（Android ID、OAID）；设备品牌与型号、操作系统版本；网络类型与运营商信息、IP 地址；软件安装列表；广告的展示、点击与播放记录。</p>
              <p><strong>使用目的：</strong>作为聚合广告的广告源之一向您展示激励视频广告，统计广告效果并进行反作弊校验与收益结算。</p>
              <p><strong>使用场景：</strong>您主动点击"观看广告获取奖励"等入口，且该广告源在聚合竞价中胜出时被调用。</p>
              <p><strong>收集方式：</strong>SDK 以嵌入式代码在设备本地读取上述信息并加密传输至其服务器。</p>
              <p><strong>官网链接：</strong><a href="https://u.kuaishou.com/" target="_blank">https://u.kuaishou.com/</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>6. SDK名称：</strong>百青藤广告SDK（百度移动联盟）</p>
              <p><strong>合作方主体：</strong>百度在线网络技术（北京）有限公司</p>
              <p><strong>涉及个人信息：</strong>设备标识符（Android ID、OAID）；设备品牌与型号、操作系统版本；网络类型与运营商信息、IP 地址；软件安装列表；广告的展示、点击与播放记录。</p>
              <p><strong>使用目的：</strong>作为聚合广告的广告源之一向您展示激励视频广告，统计广告效果并进行反作弊校验与收益结算。</p>
              <p><strong>使用场景：</strong>您主动点击"观看广告获取奖励"等入口，且该广告源在聚合竞价中胜出时被调用。</p>
              <p><strong>收集方式：</strong>SDK 以嵌入式代码在设备本地读取上述信息并加密传输至其服务器。</p>
              <p><strong>官网链接：</strong><a href="https://union.baidu.com/bqt/" target="_blank">https://union.baidu.com/bqt/</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>7. SDK名称：</strong>阿里云号码认证服务SDK（一键登录 / 短信认证）</p>
              <p><strong>合作方主体：</strong>阿里云计算有限公司（取号能力由中国移动、中国联通、中国电信提供）</p>
              <p><strong>涉及个人信息：</strong>本机号码的取号令牌与掩码号码（如 138****8000）；SIM 卡状态与运营商信息、网络类型与网络状态、IP 地址；设备厂商与型号、操作系统版本；设备标识符（Android ID、OAID）。</p>
              <p><strong>使用目的：</strong>为您提供"本机号码一键登录"与短信验证码登录，校验号码有效性、识别并拦截恶意注册与撞库行为，保障账号安全。</p>
              <p><strong>使用场景：</strong>您进入登录页、点击"一键登录"或点击"获取短信验证码"时。</p>
              <p><strong>收集方式：</strong>SDK 通过运营商数据网关完成本机号码校验，向本应用返回的是掩码号码与一次性令牌；<strong>本应用客户端不接触您的完整手机号明文</strong>，完整号码由我们的服务端凭令牌向运营商换取，仅用于创建与登录您的账号。</p>
              <p><strong>官网链接：</strong><a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html" target="_blank">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>8. SDK名称：</strong>微信 Open SDK</p>
              <p><strong>合作方主体：</strong>腾讯科技（深圳）有限公司</p>
              <p><strong>涉及个人信息：</strong>设备信息（包括设备型号、设备品牌、操作系统版本、设备唯一标识符，如 Android ID、OAID 等）；网络信息（如 IP 地址、运营商信息、网络类型、Wi-Fi 状态）；系统信息（系统设置、系统属性）；软件安装列表；微信账号相关信息（如 openID、unionID、昵称、头像、性别、语言、地区 等，需用户授权后方可获取）。</p>
              <p><strong>使用目的：</strong>实现用户使用微信账号快速登录、微信好友/朋友圈分享、微信支付、拉起微信小程序等功能，提升产品交互体验与便捷性；保障登录与支付安全；优化网络链路与服务稳定性。</p>
              <p><strong>使用场景：</strong>当用户主动选择使用"微信登录"、点击"分享到微信好友/朋友圈"、使用微信支付功能、或从本应用跳转至微信小程序时，将调用本 SDK 的相关功能模块并可能收集上述信息。</p>
              <p><strong>收集方式：</strong>SDK 在用户主动触发相关功能时，通过嵌入式代码在本地收集或向微信服务器传输所需数据。数据处理方式包括去标识化、匿名化及加密传输。未经用户授权，不会主动采集可识别个人身份的信息。</p>
              <p><strong>官网链接：</strong><a href="https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Access_Guide/Android.html" target="_blank">https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Access_Guide/Android.html</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>9. SDK名称：</strong>QQ互联SDK（腾讯开放平台）</p>
              <p><strong>合作方主体：</strong>深圳市腾讯计算机系统有限公司</p>
              <p><strong>涉及个人信息：</strong>设备标识符（Android ID、OAID）；设备品牌与型号、操作系统版本；网络类型与网络状态、IP 地址；经您授权后的 QQ 账号信息（openID、unionID、昵称、头像、性别）。</p>
              <p><strong>使用目的：</strong>实现使用 QQ 账号快捷登录本应用，并保障登录过程的安全。</p>
              <p><strong>使用场景：</strong>您主动点击"QQ 登录"时。</p>
              <p><strong>收集方式：</strong>SDK 在您主动触发登录时以嵌入式代码在本地读取上述信息并加密传输至腾讯服务器；您取消授权则不会收集账号信息。</p>
              <p><strong>官网链接：</strong><a href="https://privacy.qq.com/" target="_blank">https://privacy.qq.com/</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>10. SDK名称：</strong>支付宝支付SDK</p>
              <p><strong>合作方主体：</strong>支付宝（中国）网络技术有限公司</p>
              <p><strong>涉及个人信息：</strong>设备标识符（Android ID、OAID）；设备品牌与型号、操作系统版本；网络类型与网络状态、IP 地址；订单号、支付金额、商品信息等交易信息与支付结果。</p>
              <p><strong>使用目的：</strong>完成支付宝支付、回传订单支付结果，并进行支付安全风控与交易反欺诈。</p>
              <p><strong>使用场景：</strong>您在充值页选择使用支付宝付款时。</p>
              <p><strong>收集方式：</strong>SDK 在您主动发起支付时以嵌入式代码在本地读取上述信息并加密传输至支付宝服务器；您的支付密码、银行卡号等信息由支付宝直接采集与处理，本应用不接触、不存储。</p>
              <p><strong>官网链接：</strong><a href="https://opendocs.alipay.com/open/54/01g6qm" target="_blank">https://opendocs.alipay.com/open/54/01g6qm</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>11. SDK名称：</strong>友盟+ 基础组件SDK（UMeng Common / ASMS）</p>
              <p><strong>合作方主体：</strong>友盟同欣（北京）科技有限公司</p>
              <p><strong>涉及个人信息：</strong>设备标识符（Android ID、OAID）；设备品牌与型号、操作系统版本；网络类型与网络状态、IP 地址。</p>
              <p><strong>使用目的：</strong>本应用未主动调用该组件的统计分析功能，其作为本目录所列广告类 SDK 的依赖库随安装包集成，仅在被依赖方调用时提供基础的设备识别与网络通信能力。</p>
              <p><strong>使用场景：</strong>随依赖它的广告 SDK 一并初始化，即您同意本政策且触发广告加载时。</p>
              <p><strong>收集方式：</strong>SDK 以嵌入式代码在设备本地读取上述信息并加密传输至其服务器。</p>
              <p><strong>官网链接：</strong><a href="https://www.umeng.com/page/policy" target="_blank">https://www.umeng.com/page/policy</a></p>
            </div>
            <p id="push-sdks" class="note"><strong>推送 SDK：</strong>以下 SDK 在您同意本政策后，按设备品牌和服务支持情况启用对应通道。消息投递还涉及推送标识、消息内容及回执处理，详见“消息推送与通知管理”。</p>
            <div class="sdk-item">
              <p><strong>12. SDK名称：</strong>华为推送 SDK（HMS Core Push Kit）</p>
              <p><strong>合作方主体：</strong>华为软件技术有限公司</p>
              <p><strong>涉及信息：</strong>应用基本信息、设备型号、操作系统、系统设置信息、网络信息（网络类型、运营商名称、Wi-Fi 网络名称 SSID、IP 地址）。其中系统设置信息、运营商名称、SSID、IP 地址按厂商说明仅在设备本地处理，不上传至华为服务器。</p>
              <p><strong>使用目的与场景：</strong>在支持华为推送的华为设备上注册推送、接收通知并保障投递服务运行。</p>
              <p><strong>收集方式：</strong>SDK 在应用内调用系统接口及厂商推送服务处理上述信息，需上传的信息通过网络传输至对应厂商；注明仅本地处理的信息不上传。</p>
              <p><strong>隐私与信息处理说明：</strong><a href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177" target="_blank" rel="noopener noreferrer">华为推送 SDK（HMS Core Push Kit）官方说明</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>13. SDK名称：</strong>小米推送 SDK（Mi Push）</p>
              <p><strong>合作方主体：</strong>北京小米移动软件有限公司及其关联公司</p>
              <p><strong>涉及信息：</strong>应用包名、版本及运行状态；推送设备标识；设备厂商、型号、内存、操作系统及 SDK 版本、国家或地区、网络及通知栏设置信息；消息创建、送达、点击时间及为投递而暂存的消息内容。其中网络类型、SIM 卡运营商信息按厂商说明仅在本地处理。</p>
              <p><strong>使用目的与场景：</strong>在支持小米推送的小米、Redmi 设备上注册推送、投递通知并统计送达及点击情况。</p>
              <p><strong>收集方式：</strong>SDK 在应用内调用系统接口及厂商推送服务处理上述信息，需上传的信息通过网络传输至对应厂商；注明仅本地处理的信息不上传。</p>
              <p><strong>隐私与信息处理说明：</strong><a href="https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1534" target="_blank" rel="noopener noreferrer">小米推送 SDK（Mi Push）官方说明</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>14. SDK名称：</strong>vivo 推送 SDK</p>
              <p><strong>合作方主体：</strong>维沃移动通信有限公司</p>
              <p><strong>涉及信息：</strong>应用基本信息（应用 ID、appkey、应用包名、应用版本号、推送 SDK 版本号）、应用设备标识 regId、硬件设备类型、系统类型及版本。</p>
              <p><strong>使用目的与场景：</strong>在支持 vivo 推送的 vivo、iQOO 设备上注册推送、接收通知及统计 SDK 接口调用情况。</p>
              <p><strong>收集方式：</strong>SDK 在应用内调用系统接口及厂商推送服务处理上述信息，需上传的信息通过网络传输至对应厂商；注明仅本地处理的信息不上传。</p>
              <p><strong>隐私与信息处理说明：</strong><a href="https://developers.vivo.com/doc/d/23807c559e844cbeb06049ee69e71833" target="_blank" rel="noopener noreferrer">vivo 推送 SDK官方说明</a></p>
            </div>
            <div class="sdk-item">
              <p><strong>15. SDK名称：</strong>OPPO PUSH SDK</p>
              <p><strong>合作方主体：</strong>广东欢太科技有限公司</p>
              <p><strong>涉及信息：</strong>应用基本信息（应用包名、MCS 应用包名、应用版本号、OPPO PUSH SDK 版本号）、应用设备标识（RegistrationID）及应用注册参数（appKey、appSecret）。应用注册参数属于应用配置，不是您的个人账号密码。</p>
              <p><strong>使用目的与场景：</strong>在支持 OPPO 推送的 OPPO、realme、一加设备上注册推送并接收通知。</p>
              <p><strong>收集方式：</strong>SDK 在应用内调用系统接口及厂商推送服务处理上述信息，需上传的信息通过网络传输至对应厂商；注明仅本地处理的信息不上传。</p>
              <p><strong>隐私与信息处理说明：</strong><a href="https://open.oppomobile.com/documentation/page/info?id=11229" target="_blank" rel="noopener noreferrer">OPPO PUSH SDK官方说明</a></p>
            </div>
            <p class="note">我们会核对所接入 SDK 的信息处理范围与使用目的。接入版本或配置变化导致信息处理范围变化时，我们将相应更新本政策，并依法履行告知及征得同意等义务。您可通过各 SDK 的官方说明进一步了解其信息处理规则。</p>
          </div>

          <h4>3、为了更好地保护未成年人身心健康，引导未成年人健康上网，防止未成年人冒用、借用成年人的相关信息，我们将基于未成年人监护人的请求或我们主动保护未成年人的需要，会尝试联系其监护人，将其相关的服务帐号、上网时长、消费交易记录、上网行为等信息告知其监护人，进行提醒、确认和处理。</h4>

          <h4>4、为提升星果研发能力和服务水平，以便为您提供更优质的产品和服务，我们会在合法、合理、必要的范围内，与研究机构、科研院所、高校等机构共享经去标识化或匿名化处理后的数据。未经您的明确授权，我们不会向上述机构共享可用于识别您个人身份的信息。</h4>

          <h3>（二）转移</h3>
          <p>在我们发生合并、收购、资产转让、分立、解散、被宣告破产或类似情况时，您的个人信息有可能需要转移。我们将会将相关情况告知您，向您告知接收方的名称和联系方式，并会要求新的接收方按照法律法规及不低于本政策的的要求继续保护您的个人信息。</p>

          <h3>（三）公开</h3>
          <p>我们仅会在以下情况下，才会公开您的个人信息：</p>
          <p>1、根据您的需求，在您明确同意的情况下公开您所指定的信息；</p>
          <p>2、根据法律、行政法规的要求公开您的个人信息。</p>
        </section>

        <section class="section">
          <h2>四、我们如何存储和保护您的个人信息</h2>

          <h3>（一）个人信息的存储</h3>
          <p>除法律法规或监管部门另有规定外，我们仅在本政策所述目的所必需且最短的时限内存储您的个人信息。</p>
          <p>推送设备关联信息用于维持投递服务；消息、回执及点击记录的保存期限按消息投递、故障排查、发送频次控制及效果统计所需的最短时间确定。超出必要期限或符合删除条件时，我们将删除或匿名化处理，法律法规要求保留的除外。解除设备绑定或停用失效推送标识不等同于立即删除历史记录。</p>
          <p>如我们终止服务或运营，我们将及时停止继续收集您个人信息的活动，同时会遵守相关法律法规要求提前向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。</p>
          <p>如果你申请注销帐户、主动删除个人信息或超出必要的期限后，我们将对你的个人信息进行删除或匿名化处理，但法律法规规定有保留期限的除外。</p>
          <p>我们在中华人民共和国境内收集的个人信息，存储在中国境内，如需跨境传输的，我们会单独请求获得您的授权同意，并确保依据国家法律法规和相关监管部门的规定执行，以对您的个人信息提供足够的保护。</p>

          <h3>（二）个人信息的保护</h3>
          <p>我们非常重视信息安全，成立了专门的安全团队，并采取一切合理可行的措施，保护您的个人信息：</p>

          <h4>1、数据安全技术措施</h4>
          <p>我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问、使用、修改，避免数据的损坏或丢失。</p>
          <p>我们的服务采取了去标识化和多种加密技术，我们将利用上述技术（包括SSL）对您的个人信息进行加密保存，并通过隔离技术进行隔离，以保护您的个人信息。</p>
          <p>在个人信息使用时，包括信息展示、信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中的安全性。</p>
          <p>我们还会采用严格的数据访问权限控制保护个人信息，避免数据被违规使用。</p>

          <h4>2、我们为保护个人信息采取的其他安全措施</h4>
          <p>我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。</p>
          <p>我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</p>
          <p>我们还会举办安全和隐私保护培训课程，加强员工的安全意识以及对于个人信息保护政策和相关规程的认识。</p>
          <p>我们仅允许有必要知晓这些信息的员工、合作伙伴访问您的个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们合作关系。</p>
          <p>互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致个人信息被非授权泄露、公开、篡改、或丢失，导致您的合法权益受损，我们将按照法律的规定第一时间通知您，并承担相应的法律责任。</p>

          <h4>3、安全事件处置</h4>
          <p>为应对个人信息泄露、篡改和丢失相关的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。我们亦定期组织内部培训和应急演练，使得我们的相关工作人员掌握相应的应急处置策略和规程。</p>
          <p>当可能发生或不幸发生信息安全事件，我们将按照法律法规的要求，立即采取补救措施，并及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、网站等通知的方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。</p>

          <h4>4、安全提示</h4>
          <p>请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入本产品服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</p>
          <p>请您务必妥善保管好您的帐号、密码及其他身份要素。您在使用本产品服务时，我们会通过您的帐号、密码及其他身份要素来识别您的身份。一旦您泄露了前述信息，您可能会蒙受损失，并可能对您产生不利。如您发现帐号、密码及/或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</p>
        </section>

        <section class="section">
          <h2>五、如何行使您的个人信息相关权利</h2>
          <p>在您使用本产品服务期间，我们将根据本产品的具体情况为您提供管理您的个人信息的相应操作设置，以便您可以查阅、复制、转移、更正、补充、删除或撤回您的相关个人信息。</p>
          <p>1. 您可以在您使用的星果编辑器中查阅您的帐号基础信息（帐号头像、昵称，以及其他您选择填写的个人信息），根据具体情况更正、补充您的帐号基础信息。</p>
          <p>2. 如您有其他查阅、复制、转移、更正、补充或删除需求或您在使用本产品服务期间有任何疑问或困难，请通过本政策"如何联系我们"章节所列的反馈渠道联系我们，我们会及时为您处理。</p>
          <p class="note">除法律法规另有规定，当您更正、补充、删除您的个人信息或申请注销帐号时，我们可能不会立即从备份系统中更正、补充或删除相应的信息，但会在备份更新时更正、补充或删除这些信息。相关信息一旦被删除或者账号被注销，将无法恢复，请您谨慎操作。</p>

          <h3>（二）公开与分享</h3>
          <p>本产品的部分功能可让您上传或发布的信息、您对其他人上传或发布的信息作出的回应。只要您不删除您所公开或共享的信息，有关信息可能一直留存在公众领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或存储，或由其他用户或该等第三方在公众领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的信息。</p>

          <h3>（三）帐号注销</h3>
          <p>我们向您提供帐号注销的途径。在符合我们的服务条款约定条件及国家相关法律法规规定的情况下，您可以按照相应的要求提交账号注销申请。您也可以选择通过本政策"如何联系我们"章节所列的反馈渠道联系我们，我们会在5个工作日内尽快为您作出解答。</p>
          <p>在您的帐号注销之后，我们将停止为您提供全部或部分本产品服务，并依据您的要求，删除您的个人信息或做匿名化处理，但法律法规另有规定的除外。相关信息一旦被删除或者账号被注销，将无法恢复，请您谨慎操作。</p>

          <h3>（四）改变您授权同意的范围</h3>
          <p>您可以选择是否向我们提供个人信息。您可以通过删除信息、关闭设备功能、注销账号等方式改变您授权我们继续收集信息的范围或撤回您的授权。您也可以通过本政策“如何联系我们”章节所列的渠道联系我们撤回授权，我们会在15个工作日内进行相关操作。当撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。</p>
          <p>通过手机系统设置管理 App 授权Android（以小米/华为/OPPO等为例）路径：设置-应用管理-权限管理-选择应用-修改或撤销权限（如通讯录、位置、相机等）</p>
          <p>撤回第三方登录授权（如微信/QQ）路径：设置-账号与同步-选择微信/QQ-移除账号或取消授权。</p>
          <p>通过 App 提供「隐私管理」或「授权管理」路径：设置-个性化广告/注销。</p>

          <h3>（五）逝者近亲属的权利</h3>
          <p>如本产品用户不幸逝世，其近亲属可以通过本政策"如何联系我们"章节中的联系方式联系我们，以依法行使其对逝者的相关个人信息行使法定权利。</p>
        </section>

        <section class="section">
          <h2>六、未成年人保护</h2>
          <p>我们建议：任何未成年人参加网上活动应事先取得父母或其他监护人（以下简称"监护人"）的同意。我们将根据国家相关法律法规的规定保护未成年人的相关信息。</p>
          <p>我们鼓励监护人指导未成年人使用本产品服务。如果您是未满十四周岁的未成年人，请您通知您的监护人共同阅读我们的《星果未成年人信息保护和监护人须知》，在您使用本产品服务、提交个人信息之前，寻求其同意和指导。如果您是未成年人的监护人，当您在帮助未成年人注册、使用本产品服务前，应仔细阅读本政策和《星果未成年人信息保护和监护人须知》，决定是否同意本政策和《星果未成年人信息保护和监护人须知》并帮助未成年人注册、使用。</p>
          <p>为保护未成年人用户的健康成长，平台上线了可由家长设置的较为严格的"青少年模式"，同时，我们将对未成年人实名认证账号的相关权限进行限制，包括使用时长限制、提现（如有）限制。</p>
        </section>

        <section class="section">
          <h2>七、修订和通知</h2>
          <p>为了给您提供更好的服务，我们将会根据本产品服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分。我们会在本页面上公布对本政策所作的任何变更。对于重大变更，我们还会提供更为显著的通知（包括网站公告、推送通知、弹窗提示或其他方式），本政策所指的重大变更包括但不限于：</p>
          <p>1、我们的服务模式发生重大变化。包括处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</p>
          <p>2、我们在所有权结构方面发生重大变化。包括业务调整、破产并购等引起的所有者变更；</p>
          <p>3、个人信息共享、转让或公开的主要对象发生重大变化；</p>
          <p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
          <p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生重大变化；</p>
          <p>6、其他重要的或可能严重影响您的个人权益的情况发生。</p>
          <p>我们的任何修改都会将您的满意度置于首位。我们鼓励您在每次使用本产品服务时都查阅我们的隐私政策。</p>
          <p>对于基于您的同意处理个人信息的情形，如处理目的、处理方式或个人信息种类发生变更，我们将依法重新取得您的同意。政策更新公告不代替应当取得的授权同意。</p>
          <p>在必需时我们会向您发出与服务有关的通知。</p>
        </section>

        <section class="section">
          <h2>八、如何联系我们</h2>
          <p>我们设立了个人信息保护专职部门，将按照本政策保护您的个人信息。如您有关于个人信息保护的投诉和举报，或您对本政策、星果的隐私措施、您的信息的相关事宜有任何问题、意见或建议，您可以联系星果App客服人员，您也可以与星果的个人信息保护工作人员联系，可发送邮件至xingyuwanxiang@126.com或者与北京星域万象科技有限公司及我们取得联系。</p>
          <p>一般情况下，我们将在收到您的问题、意见或建议，并验证您的用户身份后的15个工作日内予以回复。</p>
          <p><strong>本政策更新时间：2026年10月30日</strong></p>
        </section>
      </div>
    </div>

    <!-- 底部 -->
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-links">
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
            京ICP备2025135199号-1
          </a>
        </div>
        <div class="footer-copyright">
          <p>主办单位：北京星域万象科技有限公司</p>
          <p>&copy; 2025 星果. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Privacy'
})
export default class Privacy extends Vue {
}
</script>

<style scoped lang="scss">
.privacy-page {
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  color: #333;
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* ========== 隐私政策内容 ========== */
.privacy-content {
  flex: 1;
  padding: 40px 20px 60px;
  background: #f8f9fa;
}

.content-container {
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  padding: 60px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.main-title {
  font-size: 36px;
  font-weight: bold;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 20px;
  border-bottom: 2px solid #409eff;
}

.update-date {
  text-align: center;
  color: #909399;
  font-size: 14px;
  margin: -30px 0 40px;
}

.section {
  margin-bottom: 50px;

  h2 {
    font-size: 26px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 24px;
    padding-left: 16px;
    border-left: 4px solid #409eff;
  }

  h3 {
    font-size: 20px;
    font-weight: bold;
    color: #34495e;
    margin: 30px 0 20px 0;
  }

  h4 {
    font-size: 18px;
    font-weight: bold;
    color: #5a6c7d;
    margin: 24px 0 16px 0;
  }

  p {
    font-size: 16px;
    line-height: 2;
    color: #5a6c7d;
    margin-bottom: 16px;
    text-align: justify;
  }

  .note {
    background: #f0f9ff;
    border-left: 4px solid #409eff;
    padding: 16px 20px;
    margin: 20px 0;
    border-radius: 4px;
  }

  strong {
    color: #2c3e50;
    font-weight: 600;
  }
}

.policy-update a {
  color: #1675c7;
  text-decoration: underline;
}

#push-notices,
#push-sdks {
  scroll-margin-top: 24px;
}

.tip-item {
  margin-bottom: 20px;

  p {
    margin-bottom: 12px;
  }
}

.toc {
  list-style: none;
  padding: 0;

  li {
    font-size: 16px;
    line-height: 2.2;
    color: #5a6c7d;
    padding-left: 24px;
    position: relative;

    &::before {
      content: "•";
      position: absolute;
      left: 8px;
      color: #409eff;
      font-weight: bold;
    }
  }
}

.sdk-info {
  background: #fafafa;
  padding: 30px;
  border-radius: 8px;
  margin: 30px 0;

  h4 {
    margin-top: 0;
  }

  .sdk-item {
    background: #fff;
    padding: 24px;
    border-radius: 6px;
    margin-top: 20px;

    p {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    a {
      color: #409eff;
      text-decoration: none;
      word-break: break-all;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

/* ========== 底部 ========== */
.footer {
  background: #2c3e50;
  padding: 50px 40px;
  margin-top: auto;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-links {
  margin-bottom: 20px;

  a {
    color: #ecf0f1;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s;

    &:hover {
      color: #409eff;
    }
  }
}

.footer-copyright {
  p {
    color: #95a5a6;
    font-size: 13px;
    margin: 10px 0;
    line-height: 1.6;
  }
}

/* ========== 响应式设计 ========== */
@media (max-width: 1024px) {
  .content-container {
    padding: 40px;
  }

  .main-title {
    font-size: 30px;
  }

  .section {
    h2 {
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
    }

    h4 {
      font-size: 16px;
    }
  }
}

@media (max-width: 768px) {
  .privacy-content {
    padding: 30px 15px 40px;
  }

  .content-container {
    padding: 30px 24px;
  }

  .main-title {
    font-size: 26px;
    margin-bottom: 40px;
  }

  .section {
    margin-bottom: 40px;

    h2 {
      font-size: 22px;
      margin-bottom: 20px;
    }

    h3 {
      font-size: 18px;
      margin: 24px 0 16px 0;
    }

    h4 {
      font-size: 16px;
      margin: 20px 0 14px 0;
    }

    p {
      font-size: 15px;
      line-height: 1.8;
    }
  }

  .sdk-info {
    padding: 20px;

    .sdk-item {
      padding: 16px;
    }
  }

  .footer {
    padding: 40px 20px;
  }
}

@media (max-width: 480px) {
  .content-container {
    padding: 24px 16px;
  }

  .main-title {
    font-size: 22px;
    margin-bottom: 30px;
  }

  .section {
    h2 {
      font-size: 20px;
      padding-left: 12px;
    }

    h3 {
      font-size: 17px;
    }

    h4 {
      font-size: 15px;
    }

    p {
      font-size: 14px;
      line-height: 1.8;
    }
  }

  .toc li {
    font-size: 14px;
  }
}
</style>
